import { ChurnZeroEventName } from 'api/Api.generated';
import React from 'react';
import { matchOrgKey } from 'routing';
import { routingStore } from 'stores';
import { Body, Container } from 'styles';
import { getOrgDetails } from 'styles/theme';
import { getProductRegion } from 'utils/productRegion';
import { productRegions } from 'utils/productRegions';
import { BPAUFooter } from './footers/BPAUFooter';
import { DefaultFooter } from './footers/DefaultFooter';

interface PublicLayoutComponent {
  footer?: boolean;
  wide?: boolean;
  sendEvent?: (eventName: ChurnZeroEventName, token: string | null) => void;
}

const renderFooter = (orgKey: string | null, wide: boolean, sendEvent?: (eventName: ChurnZeroEventName, token: string | null) => void) => {
  const productRegion = getProductRegion();
  const orgDetails = getOrgDetails(orgKey);

  // BP Australia gets custom footer
  if (orgKey === 'bp' && productRegion === productRegions.AUSTRALIA_REGION_NAME) {
    return (
      <BPAUFooter
        helpPhone={orgDetails.helpPhone}
        helpEmail={orgDetails.helpEmail ?? ''}
        wide={wide}
        sendEvent={sendEvent}
      />
    );
  }

  // All other orgs use the default footer
  return (
    <DefaultFooter
      helpPhone={orgDetails.helpPhone}
      helpEmail={orgDetails.helpEmail}
      footerNote={orgDetails.footerNote}
      wide={wide}
      sendEvent={sendEvent}
    />
  );
};

export const PublicLayout: React.FC<PublicLayoutComponent> = ({
  children,
  footer = true,
  wide = false,
  sendEvent = () => {},
}) => {
  const orgKey = matchOrgKey(routingStore.location);

  return (
    <Body>
      <Container wide={wide}>
        {children}
        {footer && renderFooter(orgKey, wide, sendEvent)}
      </Container>
    </Body>
  );
};
